import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Applicant, Application, BundleInfo, Company } from '@shared/models/data-model';
import { BundleInfoService } from '@shared/services/bundle-info.service';
import { RegistrationService } from '@shared/services/registration.service';
import { SoldoCookieService } from '@shared/services/soldo-cookie.service';

export const emailVerificationResolver: ResolveFn<Application> = (route, state) => {
    const registrationService = inject(RegistrationService);
    const cookieService = inject(SoldoCookieService);
    if (registrationService.getApplicationId() && cookieService.hasJWT()) {
        return registrationService.getApplication();
    } else {
        return {
            applicant: {} as Applicant,
            company: {} as Company
        } as Application;
    }
};

export interface AuthData {
    applicationList: Application[];
    bundleInfoList: BundleInfo[];
    newPlanIsValid: boolean;
}

export const authDataResolver: ResolveFn<AuthData> = async (route, state) => {
    const registrationService = inject(RegistrationService);
    const bundleInfoService = inject(BundleInfoService);
    const [ bundleInfoList, applicationList, newPlanIsValid ] = await Promise.all([
        bundleInfoService.getPlanOfferList().toPromise(),
        registrationService.getApplicationList(),
        checkPlanValidity(registrationService, bundleInfoService)
    ]);

    return {
        applicationList: applicationList,
        bundleInfoList: bundleInfoList,
        newPlanIsValid: newPlanIsValid
    }
};

const checkPlanValidity = (registrationService: RegistrationService, bundleInfoService: BundleInfoService) => {
    const plan = bundleInfoService.getNewApplicationPlan();
    const offer = bundleInfoService.getNewApplicationOffer();
    if (plan && offer) {
        return registrationService.checkPlanAndOfferValidity(plan, offer);
    }
    return Promise.resolve(false);
}
